import {createAction} from "redux-act";

export const toggleMenu = createAction<boolean>();
